import FeatureKeys from "global/constants/FeatureKeys";
import { allOf, canViewRequests, feature } from "../predicates";
import type { TourRouteParams, TourStepConfig } from "../../types/tour.types";

// The tour's route carries an :id, so every step resolves it from the URL.
const CURRENT_REQUEST: TourRouteParams = {
  id: { resolver: "currentRequestId" },
};

export const viewRequestSteps: TourStepConfig[] = [
  {
    id: "view-request-actions",
    routeParams: CURRENT_REQUEST,
    target: "viewRequest.actions",
    title: "Request actions",
    content:
      "Send a reminder, void the request, download signed copies, or save the whole setup as a template. The options change with the request's status.",
    placement: "bottom",
    when: canViewRequests,
  },
  {
    id: "view-request-documents",
    routeParams: CURRENT_REQUEST,
    target: "viewRequest.documents",
    title: "Documents",
    content:
      "Preview any file without leaving the page. Once everyone has signed, the signed copies download from here too.",
    placement: "right",
    when: canViewRequests,
  },
  {
    id: "view-request-signers",
    routeParams: CURRENT_REQUEST,
    target: "viewRequest.signers",
    title: "Signers and their progress",
    content:
      "Each recipient with their current state and the order they were asked in, so a stalled request shows exactly whose desk it is sitting on.",
    placement: "right",
    when: canViewRequests,
  },
  {
    id: "view-request-audit",
    routeParams: CURRENT_REQUEST,
    target: "viewRequest.audit",
    title: "Audit trail",
    content:
      "Every view, signature and decline, stamped with who and when. This is the record you produce if the agreement is ever questioned.",
    placement: "left",
    when: allOf(canViewRequests, feature(FeatureKeys.COMPLIANCE_AUDIT_TRAIL)),
  },
];

export default viewRequestSteps;
